import React from 'react';

import HowItWorksStep1SVG from "../../components/Images/HowItWorksStep1SVG"
import HowItWorksStep2SVG from "../../components/Images/HowItWorksStep2SVG"
import HowItWorksStep3SVG from "../../components/Images/HowItWorksStep3SVG"
import HowItWorksStep4SVG from "../../components/Images/HowItWorksStep4SVG"
import  KavitaImg from "../../pages/WritersBenefit/Author/Images/Kavita.jpg"
import  WordsImg from "../../pages/WritersBenefit/Author/Images/Words.jpg"
import  AnandImg from "../../pages/WritersBenefit/Author/Images/Anand.jpg"
import { commonFAQ } from '../../constants';



const bengali = {
  introduction_heading :'পকেট নভেলের হাত ধরে জেগে উঠুক আপনার স্বপ্নের লেখক স্বত্বা',
  create_novel_button_text: "নতুন নভেল লিখুন",
  rewards_title: <>  সম্মাননা ও পুরস্কার 🌟</>,
  rewards_para_text: <><span>বই পিছু ন্যূনতম <strong>১ লক্ষ</strong> টাকা থেকে সর্বাধিক <strong>১০ লক্ষ</strong> টাকা রোজগার করুন প্রতিবছর </span> </>,
  rewardsAndBenefitsArray: [
    {
      heading: 'New Story Bonus 🖋️',
      subHeading: <>আপনার প্রতিটি মৌলিক রচনার(উপন্যাস) ক্ষেত্রে নূন্যতম একটি নির্দিষ্ট শব্দসংখ্যা পাবলিশ করলে পাবেন এই পুরস্কার।</>,
      tableHeadings: ['নূন্যতম শব্দ ', ' পুরস্কার মূল্য'],
      table: [
        {
          wordCount: '৩০,০০০',
          reward: '₹৩০০০',
        },
      ],
      note: <>কোনওরকম কপি করা বা প্রাপ্তবয়স্ক লেখা চলবে না।</>,
      extraNotes: [
        {
          no: '১',
          text: 'লেখককে রাইটার্স বেনিফিট প্রোগ্রামে [WBP] আবেদন করতে হবে এবং চুক্তি স্বাক্ষর করতে হবে।',
        },
        {
          no: '২',
          text: '৫০০০ শব্দ লেখা হলেই চুক্তি স্বাক্ষর করা যাবে।',
        },
        {
          no: '৩',
          text: 'স্বাক্ষর করার পর আপনার লেখা যদি আমাদের নূন্যতম উৎকর্ষের মাত্রায় পৌঁছায় তাহলে পরবর্তী মাসের প্রথম সপ্তাহ থেকেই পাবেন পুরস্কার মূল্য।',
        },
      ],
    },
    {
      heading: 'Daily Update Bonus ⭐',
      subHeading: 'এই পুরস্কার মূল্য নির্ভর করছে প্রতি মাসে আপনার লেখার গুনগত মান এবং কতটা লিখছেন তার উপর। ',
      tableHeadings: ['শব্দ সংখ্যা (মাসিক)', 'পুরস্কার মূল্য'],
      table: [
        {
          wordCount: '৩০,০০০ এর কম ',
          reward: ' পেমেন্ট নয় ',
        },
        
        {
          wordCount: '৫০,০০০ -৩০,০০০  ',
          reward: '₹২০০০',
        },
        {
          wordCount: ' ৫০,০০০ এর বেশি',
          reward: '₹৬০০০',
        },
       
      ],
      note: <>এক মাসে সর্বাধিক ৫ টি চ্যাপ্টারে ছাড় মিলতে পারে। অর্থাৎ মাসে নূন্যতম ২৫ টি চ্যাপ্টার পাবলিশ করতেই হবে। </>,
      extraNotes: [
        {
          no: '১',
          text: <> রাইটার্স বেনিফিট প্রোগ্রামের আবেদনটি অনুমোদিত হলে আপনার পুরস্কার মূল্য প্রতি মাসের ১ তারিখ হিসেব করা হবে</>,
        },
        {
          no: '২',
          text: <>  প্রতি মাসের ৮ তারিখ পেমেন্ট পাবেন/ ১ তারিখের আগে চুক্তি স্বাক্ষর করলে এটি প্রযোজ্য হবে। </>,
        }
      ],
    },
    {
      heading: 'Completion Bonus 🚀',
      subHeading: 'এই পুরস্কারটি লেখক যখন তাঁর উপন্যাস সমাপ্ত করতে চাইবেন তখন পাওয়া যাবে।',
      tableHeadings: ['শব্দ সংখ্যা (সমস্ত চ্যাপ্টার মিলিয়ে)', ' পুরস্কার মূল্য'],
      table: [
        {
          wordCount: ' ২,৫০,০০০ শব্দের কম ',
          reward: 'কোনও পুরস্কার মূল্য নেই।',
        },
        {
          wordCount: '২,৫০,০০০ শব্দ থেকে ৩,৫০,০০০ শব্দ।',
          reward: '₹৫০০০',
        },
        {
          wordCount: '৩,৫০,০০০ শব্দ থেকে ৫,০০,০০০ শব্দ',
          reward: '₹১০,০০০',
        },
        {
          wordCount: '৫,০০,০০০ শব্দের এর বেশি',
          reward: '₹25,000',
        },
      ],
      note: <>গল্পটি সুন্দর ভাবে শেষ হতে হবে।</>,
      extraNotes: [
        {
          no: 1,
          text: <>আমাদের অফিসিয়াল একাউন্টে মেল পাঠান writers@pocketfm.com সাবজেক্ট টাইটেলে উল্লেখ করুন বইয়ের নাম, লেখকের নাম, উপন্যাস সমাপ্তির জন্য বোনাসের অনুরোধ |</>,
        },
        {
          no: 2,
          text: <>এডিটোরিয়াল টিমের তরফে আপনার লেখার গুনগত মান দেখে এবং কন্টেন্ট কোয়ালিটি গাইডলাইন দেখে মিলবে বোনাস। </>,
        },
      ],
    },
  ],
  deadline_content: <>   <span>এই প্রোগ্রামের আওতায় আসার সময়সীমা  </span><span role="img" aria-label="finish flag">🏁</span>   </>,
  deadline_to_enter_button: "হয়ে উঠুন একজন পকেট নভেল লেখক",
  deadline_date:31,
  deadline_date_suffix:"",
  days_or: "দিন অথবা " ,
  months_to_go:" মাস ......পর্যন্ত ",
  monthInWords:"অক্টোবর",
  month:9,
  year: 2022,
  deadline_subheading: 'একবার এই প্রোগ্রামে যুক্ত হলে সারাজীবনের জন্য এই সকল বোনাস গুলি আপনারা পাবেন। ',
  howItWorksArray : [
    {
      step: '১',
      instruction:<>৩০,০০০ শব্দ লিখুন এবং কন্ট্রাক্টের জন্য আবেদন করুন।</>,
        stepSVG:HowItWorksStep1SVG
    },
    {
      step: '২',
      instruction:<>৩০,০০০ শব্দ লিখুন এবং কন্ট্রাক্টের জন্য আবেদন করুন।</>,
        stepSVG:HowItWorksStep2SVG
  
    },
    {
      step: '৩',
      instruction:<>প্রতিদিন চ্যাপ্টার পাবলিশ করুন এবং প্রতি মাসে বোনাস পান।</>,
        stepSVG:HowItWorksStep3SVG
  
    },
    {
      step: '৪',
      instruction:<>২,৫০,০০০ শব্দ শেষ করলে এবং পাঠক মহলে আপনার লেখা সমাদৃত হলে আপনার লেখা অডিও বুক হওয়ার যোগ্যতা অর্জন করবে। অনুমোদনের পর আপনি পাবেন পারফরম্যান্স বোনাস।   </>,
        stepSVG:HowItWorksStep4SVG
  
    },
  ],
  step: "স্টেপ ১স্টেপ",
  popularWritersArray : [
    {
      writerName: 'Kavita verma ',
      novelName: 'Mein Tere Chandani  এর লেখক',
      plays: '9.8M',
      words: '820K',
      writerImgSrc: KavitaImg,
    },
    {
      writerName: 'Words Queen',
      novelName: 'Fake Love এর লেখক',
      plays: '7.7M',
      words: '540K',
      writerImgSrc: WordsImg,
    },
    {
      writerName: 'Anand Usha Borkar',
      novelName: 'Megh - Ek Shraap এর লেখক',
      plays: '1.8M',
      words: '720K',
      writerImgSrc: AnandImg,
    },
  ],
  Author_of: 'এর লেখক  ',
  popular_writter: 'জনপ্রিয় লেখকজনপ্রিয় লেখক',


  faq: <strong>বিভিন্ন প্রশ্নের উত্তরবিভিন্ন প্রশ্নের উত্তর</strong>,
  frequentlyAskedQuestionsArray : commonFAQ,
  
  write_home_earn_stable_income_text :'বাড়িতে বসে লিখুন এবং অর্থ উপার্জন করুন।',
  write_home_earn_stable_income_subheading : "আজই আপনার যাত্রা শুরু করুন। পান অসংখ্য পাঠকের প্রশংসা। প্রতিবছর বই পিছু সর্বাধিক ১০ লক্ষ টাকা উপার্জন করুন।",
  create_new_novel :"নতুন নভেল লিখুন"
 
}

// console.log(hindi.writer_dream_text)
export default bengali;